var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 13.9998L19.05 13.9998M1.94995 13.9998H3.84995M3.84995 13.9998C3.84995 15.3805 4.91327 16.4074 6.22495 16.4074C7.53663 16.4074 8.59995 15.3805 8.59995 13.9998C8.59995 12.6191 7.53663 11.627 6.22495 11.627C4.91327 11.627 3.84995 12.6191 3.84995 13.9998ZM18.1 3.99981H19.05M1.94995 3.99981H8.59995M14.775 6.36347C13.4633 6.36347 12.4 5.38052 12.4 3.99981C12.4 2.6191 13.4633 1.59961 14.775 1.59961C16.0866 1.59961 17.15 2.6191 17.15 3.99981C17.15 5.38052 16.0866 6.36347 14.775 6.36347Z",
    stroke: "#B0BCC1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDisabled);
export default __webpack_public_path__ + "static/media/filter_disabled.b1338358acf568b8557333986cd9aae1.svg";
export { ForwardRef as ReactComponent };